module.exports = "<input #geocoder type=\"text\" autofocus>\n"


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/app/components/map-config-location/map-config-location.component.html
// module id = ../../../../../src/app/components/map-config-location/map-config-location.component.html
// module chunks = main